module.exports = __webpack_public_path__ + "static/media/analytic.d33c7819.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/feature/analytic.png
 ** module id = 581
 ** module chunks = 0
 **/